<div [bentoBusyLoader]="isMainBusyLoader" class="container-fluid registration-page">
  <div class="form-group mt-3 ml-3">
    <bento-contextual-header [items]="items" (backButtonClick)="backButtonClick()"></bento-contextual-header>
  </div>
  <form [formGroup]="eventsRegistrationForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label for="event-name" class="event-name-label">Events Name <span class="text-danger">*</span>&nbsp;</label>
      <i class="bento-icon-info" ngbPopover="The name of Event Callback Registration" placement="top-left"
        popoverTitle="Event Name">
      </i>
      <br />
      <input type="text" class="form-control-event-name" id="event-name" formControlName="eventName" (keyup)="onEventNameKeyup($event)" (blur)="onEventNameFocusOut($event)" />
      <br />
      <div *ngIf="eventsRegistrationForm.controls['eventName'].invalid && (eventsRegistrationForm.controls['eventName'].dirty)">
        <small class="text-danger" *ngIf="eventsRegistrationForm.controls['eventName'].errors.required">Event Name is required</small>
      </div>
      <small class="text-danger" *ngIf="doesNotContainDash">Event Name must contain a '-' character</small>
      <small class="text-danger" *ngIf="eventNameAlreadExist">Event Name already exist</small>
    </div>
    <div class="form-group">
      <label for="event-description" class="event-description-label">Description </label>
      <br />
      <input type="text" class="form-control-event-description" id="event-description"
      (keyup)="onEventDescriptionKeyEvent($event)"
        formControlName="eventDescription" />
        <br />
        <small class="text-danger" *ngIf="emptyDescription && eventsRegistrationForm.controls['eventDescription'].dirty">Event Description is required</small>
    </div>
    <div class="form-group">
      <label for="event-callback" class="event-callback-label">Callback URL <span
          class="text-danger">*</span>&nbsp;</label>
      <i class="bento-icon-info" ngbPopover='CallbackUrl should be a valid url which starts with "https://".'
        placement="top-left" popoverTitle="Callback URL">
      </i>
      <br />
      <input type="text" class="form-control-event-callback" id="event-callback" formControlName="eventCallback" (keyup)="onEventUrlKeyEvent($event)" />
      <br />
      <small class="text-danger" *ngIf="!isValidUrl">Please enter a valid url, should follow the pattern - https://www....</small>
    </div>
    <div class="form-group">
      <label for="event-product" class="event-product-label">Product <span class="text-danger">*</span></label>
      <bento-combobox class="form-control-event-product" id="eventproduct" formControlName="eventProduct" [itemsObservable]="dataProductsEmitter" [options]="comboboxOptions">
      </bento-combobox>

    </div>
    <div class="form-group">
      <label for="event-channel" class="event-channel-label">Channel <span class="text-danger">*</span></label>
      <bento-combobox class="form-control-event-channel" id="event-channel" formControlName="eventChannel"
        [itemsObservable]="dataChannelsEmitter" [options]="comboboxOptions">
      </bento-combobox>
      <!-- {{selectedChannel | json}} -->
    </div>
    <div class="form-group">
      <label for="event-schema" class="event-schema-label">Schema</label>
      <bento-combobox class="form-control-event-schema" id="event-schema" formControlName="eventSchema" 
        [itemsObservable]="dataSchemasEmitter" [options]="comboboxSchemaOptions">
      </bento-combobox>
    </div>
    <div class="form-group">
      <label for="event-status" class="event-status-label">Status <span class="text-danger">*</span></label>
      <bento-combobox class="form-control-event-status" id="event-status" formControlName="eventStatus"
        [itemsObservable]="dataStreamStatus" [options]="comboboxOptionsStatus">
      </bento-combobox>
    </div>
    <div class="form-group">
      <table class="table table-bordered" style="width: 100%;">
        <tbody>
          <tr>
            <td class="font-weight-bold" style="width: 15%;">Additional Filters</td>
            <td>
              <table class="table table-bordered" style="width: 100%;">
                <thead>
                  <tr>
                    <td style="width: 5%;"></td>
                    <td class="font-weight-bold">Field</td>
                    <td class="font-weight-bold">Operator</td>
                    <td class="font-weight-bold">Value</td>
                  </tr>
                </thead>
                <tbody formArrayName="distributionAttributes">
                  <tr *ngFor="let attr of distributionAttributes.controls; let i = index" [formGroupName]="i">
                    <td>
                      <!-- <button type="button" class="btn btn-delete" (click)="removeAttribute(i)">X</button> -->
                      <span class="bento-icon-remove grid-action-icon" style="color:red;" (click)="removeAttribute(i)"
                        title="Remove Attribute">
                      </span>
                    </td>
                    <td class="font-weight-bold"><input class="bento-input form-control" formControlName="field" /></td>
                    <td class="font-weight-bold"><input class="bento-input form-control" formControlName="operator" />
                    </td>
                    <td class="font-weight-bold"><input class="bento-input form-control" formControlName="value" /></td>
                  </tr>
                </tbody>
              </table>
              <div class="text-left" style="color:steelblue;">
                <span class="bento-icon-add-filled grid-action-icon" (click)="addAttribute()" title="Add Attribute">
                </span>
                <span>&nbsp;Add Attribute</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="form-group">
      <button type="submit" class="btn btn-outline-primary" id="submit">Done</button>
      <button type="button" class="btn btn-outline-primary" (click)="backButtonClick()">Cancel</button>
    </div>
  </form>
</div>